import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { VoucherStore } from "../../stores/VoucherStore";
import VoucherHistoryRow from "./historyRow";

type Props = {
    voucherStore: VoucherStore
}

const VoucherHistory: React.FC<Props> = observer(({ voucherStore }: Props) => {
    const [isLoading, setLoading] = useState(false);
    const [desc, setDesc] = useState(true);
    const exporthistory = async () => {
      setLoading(true);
      await voucherStore.exportHistory();
      setLoading(false);
    }
    const orderHistory = (order: string) => {
      setDesc(!desc);
      voucherStore.sortVoucherHistory(order, desc);
    }
    return (   
      <>
        {voucherStore.voucherHistory.length > 0 ? (
        <div>
          <div className='voucher-history'>
              <div className='row history-th'>
                <div className='col col-sm-1' onClick={() => orderHistory('lastSendDate')}>Ultimo Invio</div>
                <div className='col col-sm-2' onClick={() => orderHistory('mail')}>Email</div>
                <div className='col col-sm-1' onClick={() => orderHistory('type')}>Tipo</div>
                <div className='col col-sm-1' onClick={() => orderHistory('ndg')}>NDG</div>
                <div className='col col-sm-1' onClick={() => orderHistory('vatCode')}>P.Iva/C.Fisc</div>
                <div className='col col-sm-1' onClick={() => orderHistory('voucherExpireDate')}>Scadenza Voucher</div>
                <div className='col col-sm-1' onClick={() => orderHistory('voucherState')}>Stato</div>
                <div className='col col-sm-1' onClick={() => orderHistory('voucherRegisteredStartDate')}>Data Registrazione</div>
                <div className='col col-sm-1' onClick={() => orderHistory('voucherRegisteredEndDate')}>Data Scadenza</div>
                <div className='col col-sm-1'></div>
                <div className='col col-sm-1'></div>
              </div>
            {_.map(voucherStore.voucherHistory, h => 
              <VoucherHistoryRow key={h.voucherId} voucherStore={voucherStore} h={h} />
            )}    
            <div className='row history-actions'>
              <div className='col-12'>
                <Button onClick={() => exporthistory()} disabled={isLoading}>{isLoading && <Spinner animation="grow" size="sm" />} Esporta in Excel</Button>
              </div>
            </div>
          </div>                   
        </div>) : <div className='voucher-history'><Spinner animation="grow" size="sm" /></div>}
      </>
    );
})

export default VoucherHistory;